import { Autocomplete, Button, Checkbox, TextField } from "@mui/material";
import styles from "../Settings/AppVersion.module.css";
import { getAutocompleteStyles } from "../../style/getAutoCompleteStyles";
import { useLazyQuery } from "@apollo/client";
import { GET_EVENT_OTHER_LEAGUES, GET_LEAGUE_CATEGORIES_BY_LEAGUE_ID } from "./api/addTicketsQuery";
import { useEffect, useState } from "react";
import addTicketStyles from "./AddTickets.module.css";
import { AddTicketsInput } from "./AddTickets";
import ToasterWithMessage from "../../components/shared-components/toaster";

interface TeamList {
    lc_id: string;
    lc_name: string;
}

interface LeagueInput {
    l_id: string;
}

const AddTicketsTeams = ({
    setPage,
    ticketDetails,
    setTicketDetails,
    page
}: AddTicketsInput) => {
    const [listOfTeams, setListOfTeams] = useState([]);
    const [listOfEvents, setListOfEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState<any | null>(null);
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [searchHomeTeam, setSearchHomeTeam] = useState<TeamList | null>(null);
    const [searchAwayTeam, setSearchAwayTeam] = useState<TeamList | null>(null);
    const [isNextBtnClicked, setIsNextBtnClicked] = useState(false);
    const { error } = ToasterWithMessage();

    const [getListOfTeams, { loading }] = useLazyQuery(GET_LEAGUE_CATEGORIES_BY_LEAGUE_ID, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfTeams(data?.league_categories);
        },
        onError: (err) => {
            console.log("Error at GetListOfTeams", err?.message)
        }
    });

    const [getListOfEvents] = useLazyQuery(GET_EVENT_OTHER_LEAGUES, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfEvents(data?.events || []);
            setLoadingEvents(false);
        },
        onError: (err) => {
            console.log("Error at GetListOfEvents:", err.message);
            setLoadingEvents(false);
        }
    });

    const handleSearchEvent = (_event: any, value: any | null) => {
        setSelectedEvent(value);
        setTicketDetails({
            ...ticketDetails,
            eventId: value?.e_id,
            eventName: value?.e_name
        });
    };



    const handleSearchHomeTeam = async (_event: any, value: any) => {
        setSearchHomeTeam(value);
        setTicketDetails({
            ...ticketDetails,
            homeTeamId: value?.lc_id,
            homeTeamName: value?.lc_name
        })
    }

    const handleSearchAwayTeam = async (_event: any, value: any) => {
        setSearchAwayTeam(value);
        setTicketDetails({
            ...ticketDetails,
            awayTeamId: value?.lc_id,
            awayTeamName: value?.lc_name
        })
    }

    const handleTeamNext = () => {
        setIsNextBtnClicked(true);
        if (ticketDetails?.homeTeamId && ticketDetails?.awayTeamId && ticketDetails?.homeTeamId === ticketDetails?.awayTeamId) {
            error("Home and Away teams must be different.")
        } else if ((ticketDetails?.isBulkList && searchHomeTeam) || (!ticketDetails?.isBulkList && searchHomeTeam && searchAwayTeam)) {
            setPage(2);
        }
        if (ticketDetails?.leagueType?.toLowerCase() !== "sports") {
            if (!selectedEvent) {
                error("Event is required!");
                return;
            }

            setPage(2); 
            return;
        }
    }

    const handleBulkList = (event: any) => {
        setTicketDetails({
            ...ticketDetails,
            isBulkList: event.target.checked
        })
    }

    useEffect(() => {
        setTicketDetails({
            ...ticketDetails,
            isBulkList: false
        })
        getListOfTeams({
            variables: {
                l_id: ticketDetails?.leagueId,
            }
        });
    }, [])

    useEffect(() => {
        if (ticketDetails && ticketDetails?.isBulkList) {
            setTicketDetails({
                ...ticketDetails,
                isBulkList: ticketDetails?.isBulkList
            })
        }
        if (ticketDetails && ticketDetails?.homeTeamId && ticketDetails?.homeTeamName) {
            setSearchHomeTeam({
                lc_id: ticketDetails?.homeTeamId,
                lc_name: ticketDetails?.homeTeamName
            });
        }
        if (ticketDetails && ticketDetails?.awayTeamId && ticketDetails?.awayTeamName) {
            setSearchAwayTeam({
                lc_id: ticketDetails?.awayTeamId,
                lc_name: ticketDetails?.awayTeamName
            })
        }
        if (ticketDetails && ticketDetails?.eventId && ticketDetails?.eventName) {
            setSelectedEvent({
                e_id: ticketDetails?.eventId,
                e_name: ticketDetails?.eventName
            })
        }
    }, [page])

    const handleInput = async (_event: any, value: any) => {
        if (value.length >= 3) {
            await getListOfEvents({
                variables: {
                    search_string: `%${value}%`,
                    l_id: ticketDetails?.leagueId
                }
            })
        }
    }

    return (
        <div className={styles.textFieldFullMainappversion}>

            <div>
                
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <div>
                                <Checkbox
                                    onClick={(event: any) => {
                                        handleBulkList(event);
                                    }}
                                    classes={{
                                        colorPrimary: styles.unselectCheckbox,
                                        checked: styles.selectedCheckbox,
                                    }}
                                    disableRipple
                                    checked={ticketDetails?.isBulkList}
                                //   inputProps={{
                                //     "aria-labelledby": labelId,
                                //   }}
                                //   data-testid = {`checkbox${index}`}
                                />
                                <label>Bulk List</label>
                            </div>
                        </div>

                    {ticketDetails?.leagueType?.toLowerCase() === "sports" && (
                        <>
                        <div className={addTicketStyles.container}>
                            <div className={styles.titlePlaceholderappversion} style={{ marginBottom: '10px' }}>
                                <b className={styles.AppOs}>Home Team</b>
                            </div>
                            <div>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    sx={getAutocompleteStyles(false)}
                                    options={listOfTeams ?? []}
                                    loading={loading}
                                    value={searchHomeTeam}
                                    onChange={handleSearchHomeTeam}
                                    autoHighlight
                                    getOptionLabel={(option: TeamList) => option.lc_name || "-"}
                                    isOptionEqualToValue={(option: TeamList, value: TeamList) => option.lc_id === value.lc_id}
                                    getOptionKey={(option: TeamList) => option.lc_id}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Home Team"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </div>
                            {
                                isNextBtnClicked && !searchHomeTeam && <span className={addTicketStyles.errorMessage}>Home Team is required!</span>
                            }
                        </div>


                        {!ticketDetails?.isBulkList && <div className={addTicketStyles.container}>
                            <div className={styles.titlePlaceholderappversion} style={{ marginBottom: '10px' }}>
                                <b className={styles.AppOs}>Away Team</b>
                            </div>
                            <div>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    sx={getAutocompleteStyles(false)}
                                    options={listOfTeams ?? []}
                                    loading={loading}
                                    value={searchAwayTeam}
                                    onChange={handleSearchAwayTeam}
                                    autoHighlight
                                    getOptionLabel={(option: TeamList) => option.lc_name || "-"}
                                    isOptionEqualToValue={(option: TeamList, value: TeamList) => option.lc_id === value.lc_id}
                                    getOptionKey={(option: TeamList) => option.lc_id}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Away Team"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </div>
                            {
                                isNextBtnClicked && !searchAwayTeam && <span className={addTicketStyles.errorMessage}>Away Team is required!</span>
                            }
                        </div>
                        }
                    </>
                )}

                {ticketDetails?.leagueType?.toLowerCase() !== "sports" && (
                    <div className={addTicketStyles.container}>
                        <div className={styles.titlePlaceholderappversion} style={{ marginBottom: "10px" }}>
                            <b className={styles.AppOs}>Event</b>
                        </div>
                        <div>

                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                sx={getAutocompleteStyles(false)}
                                options={listOfEvents ?? []}
                                loading={loadingEvents}
                                value={selectedEvent}
                                onChange={handleSearchEvent}
                                onInputChange={handleInput}
                                getOptionLabel={(item: any) => item?.e_name || "-"}
                                getOptionKey={(option: any) => option.e_name}
                                isOptionEqualToValue={(option, value) => option.e_id === value.e_id}
                                renderInput={(params) =>
                                (<TextField
                                    {...params}
                                    placeholder="Select Event"
                                    InputLabelProps={{ shrink: true }}
                                />
                                )}
                            />
                        </div>

                        {isNextBtnClicked && !selectedEvent && <span className={addTicketStyles.errorMessage}>Event is required!</span>}
                    </div>
                )}



                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <div className={addTicketStyles.updateButtonStyle}>
                        <Button
                            classes={{
                                root: styles.separateStyleReferral
                            }}
                            disableRipple
                            fullWidth
                            type="button"
                            onClick={handleTeamNext}
                        >
                            Next
                        </Button>
                    </div>
                </div>

            </div>


        </div>
    )
}

export default AddTicketsTeams;
